/** Release tags are `major.minor.patch`; anything else, `dev` included, cannot be ordered */
const parseVersion = (version: string | undefined) => {
    const match = version?.trim().match(/^v?(\d+)\.(\d+)\.(\d+)$/);

    return match ? match.slice(1).map(Number) : null;
};

/** Whether `candidate` is a later release than `current`; never, when either cannot be ordered */
export const isLaterVersion = (candidate: string | undefined, current: string | undefined) => {
    const next = parseVersion(candidate);
    const now = parseVersion(current);

    if (!next || !now) return false;

    const differsAt = next.findIndex((part, index) => part !== now[index]);

    return differsAt !== -1 && next[differsAt] > now[differsAt];
};
